import React, {useEffect, useState, useContext} from 'react'
import { Form, Input, Button, Checkbox, Row, Col } from 'antd';

import Map from '@arcgis/core/Map'
import WebMap from '@arcgis/core/WebMap'
import MapView from "@arcgis/core/views/MapView";
import Portal from '@arcgis/core/portal/Portal'
import Sketch from '@arcgis/core/widgets/Sketch'
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer'
import FeatureLayer from '@arcgis/core/layers/FeatureLayer'
import { auditInfoContext } from '../hooks/startAuditHook';

const MapEditor = () => {

    const [url, setURL] = useState("")
    const [urlList, setURLList] = useState([])
    const [map, setMap] = useState("")
    const [view, setView] = useState("")
    const [graLayer, setGraLayer ] = useState()
    const [sketchLayer, setSketchLayer] = useState("")
    const { auditInfo, dispatchAuditInfo } = useContext(auditInfoContext)

    const rerender = () => {

        const graphicsLayer = new GraphicsLayer();
        setGraLayer(graphicsLayer)

        var map = new WebMap({
            basemap: "arcgis-topographic",
            layers: [graphicsLayer]
        })

        setMap(map)
    
        var view = new MapView({
            container: "viewDiv",
            map: map,
        });
        setView(view)

        const sketch = new Sketch({
            layer: graphicsLayer,
            view: view,
            // graphic will be selected as soon as it is created
            creationMode: "update"
        });

        sketch.on("create", function(event) {
            if (event.state === "complete") {
                dispatchAuditInfo({type: 'updateGraphics', payload: {graphics: graphicsLayer.graphics.items}})
            }
        });


        sketch.on("delete", function(event) {
            if (event.state === "complete") {
                dispatchAuditInfo({type: 'updateGraphics', payload: {graphics: graphicsLayer.graphics.items}})
            }
        });

        sketch.on("update", function(event) {
            if (event.state === "complete") {
                dispatchAuditInfo({type: 'updateGraphics', payload: {graphics: graphicsLayer.graphics.items}})
            }
        });

        setSketchLayer(sketch)

        view.when(() => {
            view.ui.add(sketch, "top-right");
        });

        // "https://services6.arcgis.com/ASSUCX0cRvBi8Wvf/arcgis/rest/services/schweinfurthii/FeatureServer/0"
        urlList.map((url) => {
            const layer = new FeatureLayer({
                url
            });
            map.add(layer);
        })

    }

    const handleImportFeature = () => {

        setURLList([...urlList, url])
        dispatchAuditInfo({type: 'updateURL', payload: {urls: [...urlList, url] }})
        setURL("")

    }

    const saveMap = async () => {

        const screenshot = await view.takeScreenshot({
            format: "jpg",
            quality: 70
        })
        console.log('screenshot data', screenshot)
        dispatchAuditInfo({type: 'updateImg', payload: {imgData: screenshot }})
        // const graphicsData = graLayer.graphics.items
        // console.log('current graphicsData', graphicsData)
    
        // view.ui.remove(sketchLayer)
        // map.remove(graLayer)

        // const portal = new Portal({
        //     authMode: "immediate"
        // });

        // const authResp = await portal.load()
        // console.log(authResp)

        // var item = {
        //     title: "testmapV1"
        // };

        // const updateResp = await map.updateFrom(view)
        // const saveResp = await map.saveAs(item)
        // var itemPageUrl = saveResp.portal.url + "/home/item.html?id=" + saveResp.id;
        // alert('save URL is itemPageUrl')

    }

    useEffect(() => {
        rerender()
    }, [])


    useEffect(() => {
        rerender()
    }, [urlList])

    return <><Row gutter={16}>
                <Col span={12}>
                    <Input 
                        value={url} 
                        onChange={(e) => {setURL(e.target.value)}} 
                        placeholder={'please paste AirGIG URL to import data'}
                    />
                </Col>
                <Col span={12}>
                    <Button onClick={handleImportFeature}>Import Feature Layer</Button>
                    <Button onClick={saveMap}>Generate Image for doc</Button>
                </Col>
              </Row>
              <div id="viewDiv"></div>
            </>
}

export default MapEditor